import React, { useRef } from "react";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import "./PdfOpener.css";

const DocxOpener = ({ path = "" }) => {
  const containerRef = useRef(null);

  const docs = [{ uri: path }];

  return (
    <div className="App">
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            ref={containerRef}
            style={{
              width: "100vw",
              height: "89vh",
            }}
          >
            <DocViewer
              documents={docs}
              initialActiveDocument={docs[1]}
              pluginRenderers={DocViewerRenderers}
              allow
            />
          </div>
        </div>
      </div>
    </div>
  );
};
// };

export default DocxOpener;
